export default __webpack_public_path__ + "static/media/logo.c7b8add3.png";